import { Immutable } from "immer";
import React from "react";

type IProps = Immutable<{
    desktop_image: string;
    mobile_image: string;
}>;

type OrderOfferImageStyle = React.CSSProperties & {
    "--order-offer-desktop-image": string;
    "--order-offer-mobile-image": string;
};

/**
 * Decorative offer banner using CSS background-image with responsive custom
 * properties. Requires .thank-you-order-offer__container styles in each
 * consuming site with fixed dimensions and background-image rules using
 * --order-offer-desktop-image / --order-offer-mobile-image.
 */
export const OrderOfferImage = (props: IProps): React.ReactNode => {
    const style: OrderOfferImageStyle = {
        "--order-offer-desktop-image": `url("${props.desktop_image}")`,
        "--order-offer-mobile-image": `url("${props.mobile_image}")`,
    };
    return (
        <div
            style={style}
            aria-hidden="true"
            className="thank-you-order-offer__container"
        ></div>
    );
};
